import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import {
  Outlet,
  RouterProvider,
  createRootRoute,
  createRoute,
  createRouter,
} from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import './styles.css';
import Portfolio from './portfolio/Portfolio';

const Axolotl = lazy(() => import('./projects/axolotl/Axolotl'));

const rootRoute = createRootRoute({
  component: () => (
    <>
      <Outlet />
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </>
  ),
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: Portfolio,
});

const axolotlRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/projects/axolotl',
  component: () => (
    <Suspense fallback={null}>
      <Axolotl />
    </Suspense>
  ),
});

const router = createRouter({
  routeTree: rootRoute.addChildren([indexRoute, axolotlRoute]),
  defaultPreload: 'intent',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
